import { fetchMustData } from '@/components/dashboard/api'
import type { IMustResponse } from '@/types'

const fetchAllPages = async (
  accountId: string,
  accountName: string,
  productId: string,
  dimensions: string[],
  metrics: string[],
  filters: any[],
  startDate: string,
  endDate: string,
  placements: string[],
  limit: number = 100,
): Promise<IMustResponse | null> => {
  let page = 1
  let total = 0
  const items: any[] = []

  while (true) {
    const resp = await fetchMustData(
      accountId,
      accountName,
      productId,
      dimensions,
      metrics,
      filters,
      startDate,
      endDate,
      placements,
      page,
      limit,
    )

    if (!resp) return null

    total = resp.total ?? total
    items.push(...(resp.items ?? []))

    if (items.length >= total) break
    if (!resp.items || resp.items.length === 0) break
    page += 1
  }

  return { items, total }
}

export const getMustComparedAnalytics = async (
  accountId: string,
  accountName: string,
  productId: string,
  dimensions: string[],
  metrics: string[],
  filters: any[],
  startDate: string,
  endDate: string,
  prevStartDate: string,
  prevEndDate: string,
  placements: string[],
): Promise<{
  current: IMustResponse | null
  previous: IMustResponse | null
}> => {
  const [currentPeriodData, previousPeriodData] = await Promise.all([
    fetchAllPages(
      accountId,
      accountName,
      productId,
      dimensions,
      metrics,
      filters,
      startDate,
      endDate,
      placements,
    ),
    fetchAllPages(
      accountId,
      accountName,
      productId,
      dimensions,
      metrics,
      filters,
      prevStartDate,
      prevEndDate,
      placements,
    ),
  ])

  return {
    current: currentPeriodData,
    previous: previousPeriodData,
  }
}
